import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { retrieveVersion } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useApplicationVersion(): UseQueryResult<string, AxiosError> {
    const queryKey = useMemo(() => queryKeys.applicationVersion(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => retrieveVersion({ signal }).then((result) => result.data),
    });
}
